import React from 'react';
function splitArrayIntoChunksOfLen(arr, len) {
    var chunks = [], i = 0, n = arr.length;
    while (i < n) {
      chunks.push(arr.slice(i, i += len));
    }
    return chunks;
  }
const HamburgerNavigationItem = ({ links = [], contentLink = null }) => {
    let mainLinks = links.filter(link=> link.attributes['megaMenuIsHamburgerExtra'] == 'False')
    let extraLinks = links.filter(link => link.attributes['megaMenuIsHamburgerExtra'] == 'True');
    let numberItemsToAdd = mainLinks.length % 3;
    let numberItemsInOneColumn = (mainLinks.length - numberItemsToAdd) / 3;
    let mainLinksMatrix = [
        mainLinks.slice(0, numberItemsInOneColumn + numberItemsToAdd),
        mainLinks.slice(numberItemsInOneColumn + numberItemsToAdd,numberItemsInOneColumn + numberItemsToAdd + numberItemsInOneColumn),
        mainLinks.slice(numberItemsInOneColumn + numberItemsToAdd + numberItemsInOneColumn, numberItemsInOneColumn + numberItemsToAdd + numberItemsInOneColumn * 2)
    ];

    return (
        <div className="mobile-navigation-holder">
        <section className="wide">
            <div className="holder-of-close">
                <div className="close-nav">
                    <img src="/ui/assets/icons/xmark-solid.svg" className="closer" alt="stäng navigationen"/>
                </div>
            </div>
            <div className="placement">
                <div className="mobile-navigation">
                    <h3>Vårt sortiment</h3>
                    <div className="columns">
                        {
                            mainLinksMatrix.map((arr, i) => (
                            <div key={i} className="">
                                <ul>
                                    {arr.map(link=>
                                    (
                                        <li key={link.url}><a href={link.url}>{link.name}</a></li>  
                                    ))}
                                </ul>
                            </div>))
                        }
                    </div>
                    <div className="extra-things">
                        <ul>
                            {extraLinks.map(link=> (
                                <li  key={link.url}><a href={link.url}>{link.name}</a></li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    </div>
        )
}
export default HamburgerNavigationItem;